<div class="left-pane" (click)="onInteractionClicked($event)">
</div>
<content-diagram [value]="value" [total]="total" (click)="onInteractionClicked($event)"></content-diagram>
<div class="right-pane" (click)="onInteractionClicked($event)">
    <div class="panel-label">{{breakSafe(title)}}</div>
</div>
<div class="suggested" translate *ngIf="isSuggested">CONTENT.SUGGESTED</div>
<div class="available" translate *ngIf="isAvailable">CONTENT.AVAILABLE</div>
